function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.500036 11.7666C0.0213871 12.2453 0.0213876 13.0213 0.500036 13.5C0.978684 13.9786 1.75473 13.9786 2.23337 13.5L7.00007 8.73326L11.7667 13.4999C12.2454 13.9786 13.0214 13.9786 13.5001 13.4999C13.9787 13.0213 13.9787 12.2452 13.5001 11.7666L8.73341 6.99992L13.5001 2.23325C13.9787 1.75461 13.9787 0.978562 13.5001 0.499914C13.0214 0.0212655 12.2454 0.0212655 11.7667 0.499914L7.00007 5.26658L2.23337 0.499887C1.75472 0.0212398 0.978679 0.0212398 0.500031 0.499887C0.0213838 0.978535 0.0213833 1.75458 0.500031 2.23322L5.26673 6.99992L0.500036 11.7666Z",
  fill: "#6F62FF"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.4275ffd1.svg";
export { ForwardRef as ReactComponent };